import {faHome} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Field, Formik} from "formik";
import React, {useState} from "react";
import {Breadcrumb, Card, Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {resellerCompanyProfileSchema, resellerUserProfileSchema,} from "../validation";
import {selectActiveCompany, selectResellerinfo} from "../store/reducers/userCompany";

export default function ResellerProfile() {
  const {t} = useTranslation();
  const resellerData = useSelector(selectResellerinfo) || {};
  const resellerCompanyData = useSelector(selectActiveCompany) || {};

  return (
    <div className="overflow-hidden">
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4 ">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{className: "breadcrumb-dark breadcrumb-transparent"}}
          >
            <Breadcrumb.Item href="/">
              <FontAwesomeIcon icon={faHome}/>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{t("Profile")}</Breadcrumb.Item>
          </Breadcrumb>
          <h4>{t("Profile")}</h4>
          <p className="mb-0">{t("Details of your profile")}</p>
        </div>
      </div>
      <Formik
        initialValues={{
          firstName: resellerData?.first_name || "",
          lastName: resellerData?.last_name || "",
          email: resellerData?.email || "",
        }}
        onSubmit={""}
        validationSchema={resellerUserProfileSchema}
      >
        {({setFieldValue, errors, touched, handleSubmit}) => (
          <Form onSubmit={handleSubmit}>
            <Card>
              <Card.Header className="p-3">
                <h5>{t("User details")}</h5>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <Form.Group className="mb-3 col-lg-6">
                    <Form.Label>{t("First Name")}</Form.Label>
                    <Field
                      name="firstName"
                      value={resellerData?.first_name}
                      className="form-control"
                      disabled
                    />
                    {errors.firstName && touched.firstName ? (
                      <span className="error-message">
                        {t(errors.firstName)}
                      </span>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="mb-3 col-lg-6">
                    <Form.Label>{t("Prefix")}</Form.Label>
                    <Form.Control
                      value={resellerData?.prefix}
                      disabled
                    />
                  </Form.Group>
                </div>
                <div className="row">
                  <Form.Group className="mb-3 col-lg-6">
                    <Form.Label>{t("last name")}</Form.Label>
                    <Field
                      name="lastName"
                      value={resellerData?.last_name}
                      className="form-control"
                      disabled
                    />
                    {errors.lastName && touched.lastName ? (
                      <span className="error-message">
                        {t(errors.lastName)}
                      </span>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="mb-3 col-lg-6">
                    <Form.Label>{t("Email")}</Form.Label>
                    <Field
                      name="email"
                      value={resellerData?.email}
                      className="form-control"
                      disabled
                    />
                    {errors.email && touched.email ? (
                      <span className="error-message">{t(errors.email)}</span>
                    ) : null}
                  </Form.Group>
                </div>
              </Card.Body>
            </Card>
          </Form>
        )}
      </Formik>
      <Formik
        initialValues={{
          companyName: resellerCompanyData?.name || "",
          companyStreet: resellerCompanyData?.street || "",
          companyHouseNumber: resellerCompanyData?.house_number || "",
          city: resellerCompanyData?.city || "",
          companyEmail: resellerCompanyData.email || ""
        }}
        onSubmit={""}
        validationSchema={resellerCompanyProfileSchema}
      >
        {({setFieldValue, errors, touched, handleSubmit, isSubmitting}) => (
          <Form onSubmit={handleSubmit}>
            <Card className="my-5">
              <Card.Header className="p-3">
                <h5>{t("Company details")}</h5>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <Form.Group className="mb-3 col-md-6">
                    <Form.Label>{t("Company Name")}</Form.Label>
                    <Field
                      name="companyName"
                      value={resellerCompanyData?.name}
                      className="form-control"
                      disabled
                    />
                    {errors.companyName && touched.companyName ? (
                      <span className="error-message">
                        {t(errors.companyName)}
                      </span>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label> {t("COC number")}</Form.Label>
                    <Form.Control
                      value={resellerCompanyData.coc_number}
                      readOnly
                    />
                  </Form.Group>
                </div>
                <div className="row">
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label> {t("VAT Number")}</Form.Label>
                    <Form.Control
                      value={resellerCompanyData.vat_number}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>{t("Street")}</Form.Label>
                    <Field
                      name="companyStreet"
                      value={resellerCompanyData?.street}
                      className="form-control"
                      disabled
                    />
                    {errors.companyStreet && touched.companyStreet ? (
                      <span className="error-message">
                        {t(errors.companyStreet)}
                      </span>
                    ) : null}
                  </Form.Group>
                </div>
                <div className="row">
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>{t("House Number")}</Form.Label>
                    <Field
                      name="companyHouseNumber"
                      value={resellerCompanyData?.house_number}
                      className="form-control"
                      disabled
                    />
                    {errors.companyHouseNumber && touched.companyHouseNumber ? (
                      <span className="error-message">
                        {t(errors.companyHouseNumber)}
                      </span>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>{t("House number Suffix")}</Form.Label>
                    <Form.Control
                      value={resellerCompanyData?.house_number_suffix}
                      disabled
                    />
                  </Form.Group>
                </div>
                <div className="row">
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>{t("City")}</Form.Label>
                    <Field
                      name="city"
                      value={resellerCompanyData?.city}
                      className="form-control"
                      disabled
                    />
                    {errors.city && touched.city ? (
                      <span className="error-message">{t(errors.city)}</span>
                    ) : null}
                  </Form.Group>

                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>{t("Country")}</Form.Label>
                    <select
                      className="form-control user-select"
                      value={resellerCompanyData.country}
                      disabled
                    >
                      <option value={t("Netherlands")}>
                        {t("Netherlands")}
                      </option>
                    </select>
                  </Form.Group>
                </div>
                <div className="row">
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>Postcode</Form.Label>
                    <Form.Control
                      value={resellerCompanyData?.postcode}
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>{t("Email")}</Form.Label>
                    <Field
                      name="companyEmail"
                      value={resellerCompanyData?.email}
                      className="form-control"
                      disabled
                    />
                    {errors.companyEmail && touched.companyEmail ? (
                      <span className="error-message">
                        {t(errors.companyEmail)}
                      </span>
                    ) : null}
                  </Form.Group>
                </div>
                <div className="row">
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>{t("Phone Number")}</Form.Label>
                    <Form.Control
                      value={resellerCompanyData?.phone_number}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label>{t("Website")}</Form.Label>
                    <Form.Control
                      value={resellerCompanyData?.website_url}
                      disabled
                    />
                  </Form.Group>
                </div>
              </Card.Body>
            </Card>
          </Form>
        )}
      </Formik>
    </div>
  );
}
